module.exports = __webpack_public_path__ + "static/media/undraw_alert_re_j2op.8147b037.svg";